module.exports = __webpack_public_path__ + "media/images/emblems/Daerligen-coat_of_arms-3a64bc76ad6a5eca707e846c59980f39.svg";